import axios from 'axios';
import { getAccessToken, clearTokens } from './tokenService';
import { refreshAccessToken } from './authService';
console.log('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXxx')
const axiosInstance = axios.create();

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });

    failedQueue = [];
};

// Token ekleyerek her isteğe Authorization header'ı koy
axiosInstance.interceptors.request.use(
    config => {
        // console.log('CONFFF',config)
        const token = getAccessToken();
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
    },
    error => Promise.reject(error)
);

// 401 yakalayınca refresh yap ve isteği tekrar dene
axiosInstance.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            if (isRefreshing) {
                return new Promise(function (resolve, reject) {
                    failedQueue.push({ resolve, reject });
                })
                    .then(token => {
                        console.log('oldAccessToken request',token);

                        originalRequest.headers['Authorization'] = 'Bearer ' + token;
                        return axiosInstance(originalRequest);
                    })
                    .catch(err => Promise.reject(err));
            }

            originalRequest._retry = true;
            isRefreshing = true;

            try {
                const newToken = await refreshAccessToken();
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + newToken;
                processQueue(null, newToken);
                console.log('originalRequest',originalRequest);
                return axiosInstance(originalRequest);
            } catch (err) {
                processQueue(err, null);
                clearTokens();
                return Promise.reject(err);
            } finally {
                isRefreshing = false;
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
